import { render } from "./ConsumptionsCalculator.vue?vue&type=template&id=9ddfaffc"
import script from "./ConsumptionsCalculator.vue?vue&type=script&lang=js"
export * from "./ConsumptionsCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__